import { z } from 'zod';

export { ColorSchema as ColorType } from './ColorSchema';

export const PositionType = z.object({
  row: z.number().describe('Row number (1-indexed)'),
  rowSpan: z.number().optional(),
  column: z.number().describe('Column number (1-indexed)'),
  columnSpan: z.number().optional(),
});

export const InstanceIdType = z.object({ space: z.string(), externalId: z.string() });
export type InstanceIdType = z.infer<typeof InstanceIdType>;
